"use strict";

import angular from "angular";
import core from "../../core.module";
import kioskLogin from "./components/kioskLogin";
import kioskPairing from "./components/kioskPairing";
import _ from "lodash";

let components = [kioskLogin, kioskPairing];
let module = angular.module("common.kiosk", [core]);

_.forEach(components, function (component) {
    module.component(component.name, component);
});

module.config(function ($translateProvider) {
    "ngInject";
    _.forEach(components, function (component) {
        _.forEach(component.translations, function (table, language) {
            $translateProvider.translations(language, table);
        });
    });
});

export default module;
